import React, { useEffect, useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import { useSelector } from 'react-redux';

function AddEditReferralInsurancePopup({
  onClose,
  typeState,
  onReload,
  editPopup,
  setEditPopup,
}) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');
  const [formData, setFormData] = useState({
    insPayerName: '',
    insuranceTypeId: '',
    insuranceAddress: '',
    insuranceCity: '',
    insuranceState: '',
    insuranceZip: '',
    insuranceEmail: '',
    insuranceDeskPhone: '',
    insuranceCell: '',
    insuranceFax: '',
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/commonTask/openAddEditMasterPopup', {
          userId: user?.id,
          insuranceId: editPopup?.referringMasterId,
          popUpType: 'insurance',
        });
        if (response.status === 200) {
          setData(response.data);
          setFormData({
            id: response.data.insuranceMaster[0]?.id || '',
            insPayerName:
              response.data.insuranceMaster[0]?.insurance_company_name || '',
            insuranceTypeId:
              response.data.insuranceMaster[0]?.insurance_master_id || '',
            insuranceAddress: response.data.insuranceMaster[0]?.address_1 || '',
            insuranceCity: response.data.insuranceMaster[0]?.city || '',
            insuranceState: response.data.insuranceMaster[0]?.state || '',
            insuranceZip: response.data.insuranceMaster[0]?.zip || '',
            insuranceEmail: response.data.insuranceMaster[0]?.email || '',
            insuranceDeskPhone: response.data.insuranceMaster[0]?.phone_l || '',
            insuranceCell: response.data.insuranceMaster[0]?.phone_m || '',
            insuranceFax: response.data.insuranceMaster[0]?.fax || '',
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup, user?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSaveUpdate = async () => {
    try {
      if (!formData?.insPayerName) {
        setUiMessage('err', 'Please enter Payer Name');
      } else if (!formData?.insuranceTypeId) {
        setUiMessage('err', 'Please select Type');
      } else if (!formData?.insuranceAddress) {
        setUiMessage('err', 'Please enter Address');
      } else if (!formData?.insuranceCity) {
        setUiMessage('err', 'Please enter City');
      } else if (!formData?.insuranceState) {
        setUiMessage('err', 'Please enter State');
      } else if (!formData?.insuranceZip) {
        setUiMessage('err', 'Please enter Zip');
      } else if (!formData?.insuranceEmail) {
        setUiMessage('err', 'Please enter Email');
      } else if (!formData?.insuranceDeskPhone) {
        setUiMessage('err', 'Please enter Desk Phone');
      } else if (!formData?.insuranceFax) {
        setUiMessage('err', 'Please enter Fax');
      } else {
        const response = await post(
          'api/commonTask/saveUpdateInsuranceMaster',
          {
            userId: user?.id,
            insuranceId: editPopup?.referringMasterId || '',
            ...formData,
          }
        );
        if (response.status === 200) {
          setUiMessage('suc', 'Insurance added successfully.');
          onReload();
          onClose();
        }
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        {/* Header */}
        <div className="addressBookHeader">
          <span className="addressTitle">
            <h2>Add New Insurance</h2>
          </span>
          <span className="addressClose" onClick={onClose}>
            X
          </span>
        </div>

        {/* Body */}
        <div className="addressBody">
          {/* Row: Payer Name + Type */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Payer Name *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insPayerName"
                  value={formData.insPayerName}
                  onChange={handleChange}
                  placeholder="Payer Name"
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Type *</div>
              <div className="addressBodyRow">
                <select
                  name="insuranceTypeId"
                  id="insurance_type_id"
                  className="chzn-select addressBookSearh"
                  style={{ height: '40px' }}
                  value={formData.insuranceTypeId}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.insuranceType &&
                    data?.insuranceType?.length > 0 &&
                    data?.insuranceType?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="addressBodyRow">Street Address *</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="insuranceAddress"
              value={formData.insuranceAddress}
              onChange={handleChange}
              placeholder="Street Address"
            />
          </div>

          {/* City / State / Zip */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">City *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insuranceCity"
                  value={formData.insuranceCity}
                  onChange={handleChange}
                  placeholder="City"
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">State *</div>
              <div className="addressBodyRow">
                <select
                  name="insuranceState"
                  id="insuranceState"
                  className="chzn-select addressBookSearh"
                  style={{ height: '40px' }}
                  value={formData.insuranceState}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.stateMaster &&
                    data?.stateMaster?.length > 0 &&
                    data?.stateMaster.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.stateName}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Zip *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insuranceZip"
                  value={formData.insuranceZip}
                  onChange={handleChange}
                  maxLength="5"
                  placeholder="Zip"
                />
              </div>
            </div>
          </div>

          {/* Email */}
          <div className="addressBodyRow">Email *</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh"
              type="text"
              name="insuranceEmail"
              value={formData.insuranceEmail}
              onChange={handleChange}
              placeholder="Email address"
            />
          </div>

          {/* Phones */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Desk Phone *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insuranceDeskPhone"
                  value={formData.insuranceDeskPhone}
                  onChange={handleChange}
                  maxLength="10"
                  placeholder="Main phone number"
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Cell Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insuranceCell"
                  value={formData.insuranceCell}
                  onChange={handleChange}
                  maxLength="10"
                  placeholder="Mobile number"
                />
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Fax *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh"
                  type="text"
                  name="insuranceFax"
                  value={formData.insuranceFax}
                  onChange={handleChange}
                  maxLength="10"
                  placeholder="Fax number"
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="addressBodyRow">
            <div
              style={{ marginLeft: '10px' }}
              className="button-submit right"
              onClick={() => {
                // onUpdate(formData.id, formData)
                onSaveUpdate();
              }}
            >
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </div>

            <div className="button-submit right" onClick={onClose}>
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralInsurancePopup;
